import React, { useState } from 'react';
import { Modal, ModalHeader, ModalBody, Button, ModalFooter } from 'reactstrap';
import { getTranslationKey } from '../../modules/utils/helpers';
import { InputItem } from '../Forms/InputItem';

interface IProps {
  onClose: () => void;
  onConfirm: (name: string) => void;
  isOpen: boolean;
}

export const CreateCouponModal = ({ onClose, isOpen, onConfirm }: IProps) => {
  const [name, setName] = useState('');

  const closeModal = () => {
    setName('');
    onClose();
  };

  const createNewPresetHandler = () => {
    if (name.length) {
      onConfirm(name);
      closeModal();
    }
  };

  const handleNameChange = (value: string) => {
    setName(value.trim());
  };

  return (
    <Modal isOpen={isOpen} toggle={closeModal} wrapClassName="modal-dark" size="default" centered>
      <ModalHeader toggle={closeModal}>
        {getTranslationKey('shop.coupons.createCouponModalTitle')}
      </ModalHeader>
      <ModalBody>
        <InputItem
          value={name}
          placeholder="Name"
          withTooltip={false}
          label={getTranslationKey('shop.coupons.createCouponNameLabel')}
          changeCallback={handleNameChange}
        />
      </ModalBody>
      <ModalFooter>
        <Button
          block
          color="success"
          disabled={!name.length}
          onClick={createNewPresetHandler}
          className="btn btn-primary"
        >
          {getTranslationKey('galleryPresets.createButton')}
        </Button>
      </ModalFooter>
    </Modal>
  );
};
